import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'
import { FormColourPicker } from '$components'
import { ServiceColour } from '../../components/colour-input'

export function EditServiceDetailsContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <div className="flex sm:flex-row flex-col gap-6">
        <FormFieldGroup className="w-fit">
          <FormLabel htmlFor={Input.Colour}>
            Service Colour
          </FormLabel>

          <FormColourPicker
            name={Input.Colour}
            options={Object.values(ServiceColour).map(colour => ({ value: colour }))}
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.Name}>
            Service Name
          </FormLabel>

          <FormInput
            name={Input.Name}
            placeholder="Enter service name..."
          />
        </FormFieldGroup>
      </div>
    </div>
  )
}
